module.exports = __webpack_public_path__ + "img/any-mbg5.fe021cc4.png";